import React, {useEffect, useState} from 'react';
import {PageWrapper} from "../../../components/UI/PageWrapper/PageWrapper";
import {CustomCard} from "../../../components/UI/AntCustom/CustomCard";
import {CurrencyCard} from "./components/CurrencyCard";
import {defineMessages, useIntl} from "react-intl";
import {BillingApiCurrencyListRequest, PageModel} from "../../../proto/generated/api_entities_pb";
import {BillingApi} from "../../../API/ApiClasses/BillingApi";
import {InitialPage} from "../../../utils/constans/pagination/pagination";
import {PageModelLimits} from "../../../utils/constans/pagination/pageModelLimits";
import {CurrencyEntity} from "../../../proto/generated/api_entities_pb";
import {message} from "antd";

const CurrenciesPageMessages = defineMessages({
  title: {
    id: "currenciesPage.title",
    defaultMessage: "Currency management",
  },
  loading: {
    id: "currenciesPage.loading",
    defaultMessage: "Loading currencies...",
  },
  error: {
    id: "currenciesPage.error",
    defaultMessage: "Failed to load currencies",
  },
  updateSuccess: {
    id: "currenciesPage.updateSuccess",
    defaultMessage: "Currency updated successfully",
  },
  setBaseSuccess: {
    id: "currenciesPage.setBaseSuccess",
    defaultMessage: "Base currency changed successfully",
  },
})

export const CurrenciesPage = () => {
  const intl = useIntl();
  const [currencies, setCurrencies] = useState<CurrencyEntity[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const loadCurrencies = async () => {
    try {
      setLoading(true);
      const req = new BillingApiCurrencyListRequest()
        .setPagemodel(
          new PageModel().setPage(InitialPage).setLimit(1000)
        );

      const response = await BillingApi.getCurrencyList(req);
      setCurrencies(response.getCurrenciesList());
    } catch (error) {
      message.error(intl.formatMessage(CurrenciesPageMessages.error));
      console.error('Failed to load currencies:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCurrencies();
  }, []);

  const handleCurrencyUpdate = () => {
    loadCurrencies();
    message.success(intl.formatMessage(CurrenciesPageMessages.updateSuccess));
  };

  const handleSetBaseCurrency = () => {
    loadCurrencies();
    message.success(intl.formatMessage(CurrenciesPageMessages.setBaseSuccess));
  };

  return (
    <PageWrapper>
      <CustomCard title={intl.formatMessage(CurrenciesPageMessages.title)} width={'max'}>
        {loading ? (
          <div>{intl.formatMessage(CurrenciesPageMessages.loading)}</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {currencies.map((currency) => (
              <CurrencyCard
                key={currency.getCurrencyid()}
                currency={currency}
                onUpdate={handleCurrencyUpdate}
                onSetBase={handleSetBaseCurrency}
              />
            ))}
          </div>
        )}
      </CustomCard>
    </PageWrapper>
  );
};

